export enum DeviceSampleType {
  Saliva = "SL",
  Urine = "UR"
}
